import React from 'react';
import { $ } from '@starberry/components';
import PageHero from './PageHero';

export default {
    $: 'Flex',
    children: [
        {
            $: 'SimpleTabs',
            props: {
                w: '100%',
                tabs: [
                    {
                        title: 'Overview',
                        id: 'overview',
                        content: {
                            $: '2Column',
                            props: {
                                px: 0,
                            },
                            leftColumn: [
                                {
                                    $: 'Stack',
                                    children: [
                                        {
                                            $: 'SimpleTabs',
                                            props: {
                                                tabProps: {
                                                    fontSize: 20,
                                                },
                                                // tabPanelProps: {  },
                                                tabListProps: {
                                                    p: 0,
                                                },
                                                tabs: [
                                                    {
                                                        title: 'Pending Actions',
                                                        id: 'pending-actions',
                                                        content: {
                                                            $: 'PendingActions',
                                                            hideTitle: true,
                                                        },
                                                    },
                                                    {
                                                        title: 'Recent Activity',
                                                        id: 'recent-activity',
                                                        content: {
                                                            $: 'ActivityHistory',
                                                            hideTitle: true,
                                                        },
                                                    },
                                                ],
                                            },
                                        },
                                    ],
                                },
                            ],
                            rightColumn: [
                                { $: 'BookViewingButton' },
                            ],
                        },
                    },
                    {
                        title: 'Appointments',
                        id: 'appointments',
                    },
                    {
                        title: 'Feedback',
                        id: 'feedback',
                    },
                    {
                        title: 'Offers',
                        id: 'offers',
                    },
                    {
                        title: 'Documents',
                        id: 'documents',
                    },
                ],
            },
        },
    ],
}